
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/promotionUnavailable",
      function () {
        return require("private-next-pages/loyalty/promotionUnavailable/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/promotionUnavailable"])
      });
    }
  